import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export default function ErrorPage() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1a1a2e 0%, #2d1b4e 50%, #1f1a3f 100%)",
        textAlign: "center",
        px: { xs: 1, sm: 4 },
        py: { xs: 2, sm: 6 },
        overflow: "hidden",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        style={{ width: "100%" }}
      >
        <Box
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            backdropFilter: "blur(10px)",
            boxShadow: "0px 8px 40px rgba(140, 0, 255, 0.15)",
            borderRadius: "16px",
            p: { xs: 2.5, sm: 6 },
            // maxWidth: "550px",
            width: "80%",
            mx: "auto",
            border: "2px solid rgba(140, 0, 255, 0.2)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <motion.div
            animate={{ scale: [1, 1.1, 1] }}
            transition={{ duration: 2, repeat: Infinity }}
          >
            <ErrorOutlineIcon
              sx={{
                fontSize: { xs: 60, sm: 90 },
                color: "#8C00FF",
                mb: { xs: 2, sm: 3 },
              }}
            />
          </motion.div>

          <Typography
            component="h1"
            sx={{
              fontWeight: 800,
              color: "#fff",
              mb: { xs: 1, sm: 1.5 },
              fontSize: { xs: "1.6rem", sm: "2.8rem" },
              lineHeight: 1.2,
              fontFamily: "Poppins, sans-serif",
            }}
          >
            Looking for something?
          </Typography>

          <Typography
            sx={{
              mb: { xs: 2.5, sm: 3 },
              color: "rgba(255, 255, 255, 0.8)",
              fontSize: { xs: "0.95rem", sm: "1.1rem" },
              maxWidth: "100%",
              mx: "auto",
              lineHeight: 1.6,
              fontFamily: "Poppins, sans-serif",
            }}
          >
            We're sorry — the web address you entered isn’t a functioning page on our site.
          </Typography>

          <Button
            variant="contained"
            onClick={() => navigate("/")}
            sx={{
              backgroundColor: "#ff6b35",
              textTransform: "none",
              borderRadius: "10px",
              px: { xs: 2.5, sm: 4 },
              py: { xs: 1.1, sm: 1.5 },
              fontWeight: 700,
              fontSize: { xs: "0.95rem", sm: "1.1rem" },
              boxShadow: "0px 4px 15px rgba(255, 107, 53, 0.3)",
              fontFamily: "Poppins, sans-serif",
              width: { xs: "100%", sm: "auto" },
              "&:hover": {
                backgroundColor: "#e05a28",
                boxShadow: "0px 6px 20px rgba(255, 107, 53, 0.4)",
              },
            }}
          >
            Go Back Home
          </Button>
        </Box>
      </motion.div>

      <Typography
        sx={{
          color: "rgba(255, 255, 255, 0.6)",
          mt: { xs: 2, sm: 6 },
          fontSize: { xs: "0.8rem", sm: "0.9rem" },
          fontFamily: "Poppins, sans-serif",
        }}
      >
        © {new Date().getFullYear()} PaperLive Learning
      </Typography>
    </Box>
  );
}
